import { createCardLayoutStyles } from '~/pages/anatomy/quizBinaryChoice/libs/styles/cardLayout'
import { COLORS } from '~/shared/constants/uiConstants'

export const Styles = createCardLayoutStyles({
  secondBehind: '#fdfcf7',
  firstBehind: '#ffd387',
  front: COLORS.PURPLE_100,
})
